import { useId } from 'react'

import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Label, RadioGroup, RadioGroupItem } from '@/components/ui'
import { FormField } from '@/components/ui/form'
import { CardEtapaItem, CardEtapaContent } from '@/features/proposta/components/ui'
import type { TDetalhesPropostaSchema } from '@/features/proposta/schemas/detalhes-proposta-schema'
import { TIPO_ASSINATURA_OPTIONS } from '@/features/proposta/utils/constants'

export const AssinaturaContratoStep = () => {
  const id = useId()
  const { t } = useTranslation('proposta')
  const { control, watch, setValue } = useFormContext<TDetalhesPropostaSchema>()

  const handleSelecionarTipoAssinatura = () => {
    if (!watch('detalhesDaProposta.termosDaProposta')) return
    setValue('detalhesDaProposta.termosDaProposta', '')
  }

  return (
    <CardEtapaItem
      titulo={t('detalhes_proposta.assinaturas.titulo')}
      descricao={t('detalhes_proposta.assinaturas.descricao')}
      completed={Boolean(watch(`detalhesDaProposta.assinaturaContrato`))}
    >
      <CardEtapaContent>
        <span className="text-sm font-medium text-neutral-800">
          {t('detalhes_proposta.assinaturas.modelo_assinatura')}
        </span>
        <FormField
          name="detalhesDaProposta.assinaturaContrato"
          control={control}
          render={({ field }) => (
            <RadioGroup
              className="flex flex-col gap-6"
              value={field.value}
              onValueChange={(v) => {
                field.onChange(v)
                handleSelecionarTipoAssinatura()
              }}
            >
              <div className="flex items-center gap-2">
                <RadioGroupItem value="Eletronica" id={`${id}-Eletronica`} />
                <Label className="font-normal" htmlFor={`${id}-Eletronica`}>
                  {TIPO_ASSINATURA_OPTIONS.Eletronica}
                </Label>
              </div>
              <div className="flex items-center gap-2">
                <RadioGroupItem value="Impressa" id={`${id}-Impressa`} />
                <Label className="font-normal" htmlFor={`${id}-Impressa`}>
                  {TIPO_ASSINATURA_OPTIONS.Impressa}
                </Label>
              </div>
            </RadioGroup>
          )}
        />
      </CardEtapaContent>
    </CardEtapaItem>
  )
}
